import React from 'react';
import { string } from 'prop-types';

const ClockIcon = ({ color = 'fourth-color', fontSize = 'var(--base-small)', className = '' }) => (
  <span
    style={{
      color: `var(--${color})`,
      fontSize: fontSize
    }}
    className={`icon-ic_timestamp ${className}`}
  />
);

ClockIcon.propTypes = {
  color: string,
  fontSize: string,
  className: string
};

export default ClockIcon;
